@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.bannerContainer {
  position: absolute;
  display: flex;
  left: 0;
  right: 0;
  top: 0;
  height: var(--trial-banner-height);
  z-index: 1000;

  .close {
    position: absolute;
    display: flex;
    align-items: center;
    height: 100%;
    top: 0;
    bottom: 0;
    right: 4px;

    button {
      padding: 0px;
      width: 22px;
      height: 22px;
      min-height: unset;
    }
  }
}

.banner {
  position: absolute;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  inset: 0;
  background: linear-gradient(270deg, #faa701 0%, #f907d4 100%);
  backdrop-filter: blur(50%);
  color: var(--light-100);
  @include sm-sohne-medium;

  &:focus,
  &:hover {
    outline: none;
    cursor: pointer;
    filter: brightness(90%);
  }

  .oldPercent {
    position: relative;
    color: var(--light-60);
    font-weight: 400;
    margin: 0 4px;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 2px;
      left: -4px;
      width: 100%;
      height: 1px;
      background-color: #ffffff;
      transform: rotate(-35deg);
      transform-origin: top right;
    }
  }
}

.modal {
  h1 {
    width: 480px;
  }

  .annualPrice {
    display: flex;
    align-items: center;
    @include md-sohne;
    color: var(--dark-80);
    margin-right: 14px;

    .oldPrice {
      @include xs-sohne-book;
      color: var(--dark-60);
      margin-right: 6px;
      text-decoration: line-through;
    }
  }

  .modalContent {
    @include md-sohne;

    .bold {
      font-weight: 700;
    }
  }
}
